import * as Types from './userActionTypes.js'

const initialState = {
    userToken: '',
    userInfo: '',
    isAdministrator: false,
    isPloegchef: false,
    isOperator: false,
    isQA: false,
    userPermissions: [],
};

export default function user(state = initialState, action) {
  
    switch (action.type) {
        
        case Types.SET_USERTOKEN:
            if (state.userToken !== action.userToken) {
                return Object.assign({}, state, { userToken: action.userToken });
            }
            return state;
        case Types.SET_USERINFO:
            if (state.userInfo !== action.userInfo) {
                if(action.userInfo.role !== undefined && action.userInfo.role !== null){
                    if (action.userInfo.role.includes("Operator")) {
                        if(!state.isOperator){
                            state.isOperator = true;
                        }
                    }
                    if (action.userInfo.role.includes("Ploegchef")) {
                        if(!state.isPloegchef){
                            state.isPloegchef = true;
                        }
                    }
                    if (action.userInfo.role.includes("Administrator")) {
                        if(!state.isAdministrator){
                            state.isAdministrator = true;
                        }
                    }
                    if (action.userInfo.role.includes("QA")) {
                        if(!state.isQA){
                            state.isQA = true;
                        }
                    }
                }     
                return Object.assign({}, state, { userInfo: action.userInfo });
            }

            return state;
            case Types.SET_USERPERMISSIONS:
                console.log('STATE ', state)
            if (state.userPermissions !== action.userPermissions) {
                return Object.assign({}, state, { userPermissions: action.userPermissions });
            }
            return state;
        default:
            return state;
    }
}